import React, {Fragment} from 'react';
import Navbar from '../../components/Navbar'
import PageTitle from '../../components/pagetitle'
import BlogSingle from '../../components/BlogDetails'
import Footer from '../../components/footer'
import Scrollbar from '../../components/scrollbar'
import { Helmet } from 'react-helmet';


const BlogDetails =() => {
    return(
        <Fragment>
            <Helmet>
                <title>[Blog Title] | Dar-ul-Quran Academy UK</title>
                <meta name="description" content="[Short blog description or excerpt]." />
                <link rel="canonical" href="https://www.thedarulquran.com/[blog-slug]" />
            </Helmet>
            <Navbar/>
            <PageTitle pageTitle={'Latest News'} pagesub={'Blog'} hideText={true}/> 
            <BlogSingle/>
            <Footer footerClass={'wpo-ne-footer-2'}/>
            <Scrollbar/>
        </Fragment>
    )
};
export default BlogDetails;
